var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ia-block-card pa-4 ff-guia-simulacao",
      attrs: {
        role: "group",
        "aria-label": _vm.textos.titulo,
        "aria-busy": _vm.processando ? "true" : "false"
      }
    },
    [
      _c("div", { staticClass: "mb-4" }, [
        _c(
          "span",
          {
            staticClass: "az-ds-label d-block",
            attrs: { "data-teste": "simulacao-sobretitulo" }
          },
          [_vm._v(_vm._s(_vm.textos.sobretitulo))]
        ),
        _c(
          "span",
          {
            staticClass: "ia-titulo-de-cartao d-block",
            attrs: { "data-teste": "simulacao-titulo" }
          },
          [_vm._v(_vm._s(_vm.textos.titulo))]
        )
      ]),
      !_vm.publicavel
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-start px-4 py-3 ff-guia-simulacao__aviso",
              attrs: { "data-teste": "simulacao-nao-fechou", role: "alert" }
            },
            [
              _c("icon-svg", {
                staticClass: "mr-2 flex-shrink-0",
                attrs: {
                  name: "info-circle",
                  size: 18,
                  color: "var(--text-muted)"
                }
              }),
              _c("p", { staticClass: "az-ds-body mb-0" }, [
                _vm._v(_vm._s(_vm.textos.naoFechou))
              ])
            ],
            1
          )
        : [
            _vm.avisoCarteiraPendente
              ? _c(
                  "BaseAlert",
                  {
                    staticClass: "mb-4",
                    attrs: {
                      "data-teste": "simulacao-aviso-carteira-pendente",
                      status: "warning"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.avisoCarteiraPendente) + " ")]
                )
              : _vm._e(),
            _c("FeeLabKpiStrip", {
              staticClass: "mb-4",
              attrs: {
                "data-teste": "simulacao-kpis",
                resultado: _vm.resultado,
                auc: _vm.auc,
                canal: _vm.canal
              }
            }),
            _c("FeeLabRegimeCards", {
              staticClass: "mb-4",
              attrs: {
                "data-teste": "simulacao-regimes",
                resultado: _vm.resultado,
                auc: _vm.auc,
                canal: _vm.canal
              }
            }),
            _vm.alocacaoComparada
              ? _c("FeeLabAlocacaoPizzas", {
                  staticClass: "mb-4",
                  attrs: {
                    "data-teste": "simulacao-alocacao",
                    linhas: _vm.alocacaoComparada.linhas
                  }
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "az-card-bordered no-shadow mb-4" },
              [
                _c("FeeLabProjecaoChart", {
                  attrs: {
                    "data-teste": "simulacao-projecao",
                    resultado: _vm.resultado,
                    state: _vm.estado
                  }
                })
              ],
              1
            ),
            _vm.mostraEvolucao
              ? _c("FeeLabEvolucaoPatrimonio", {
                  staticClass: "mb-4",
                  attrs: {
                    "data-teste": "simulacao-evolucao",
                    state: _vm.estado
                  }
                })
              : _vm._e(),
            _c(
              "p",
              {
                staticClass: "az-ds-label mb-2",
                attrs: { "data-teste": "simulacao-premissas-titulo" }
              },
              [_vm._v(" " + _vm._s(_vm.textos.premissas) + " ")]
            ),
            _c(
              "ul",
              { staticClass: "ff-guia-simulacao__premissas mb-4" },
              _vm._l(_vm.linhasDeclaradas, function(linha) {
                return _c(
                  "li",
                  {
                    key: linha.chave,
                    staticClass: "az-ds-aux ff-guia-simulacao__item",
                    attrs: { "data-teste": "simulacao-premissa" }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(linha.rotulo) +
                        ": " +
                        _vm._s(linha.valor) +
                        " "
                    )
                  ]
                )
              }),
              0
            )
          ],
      _vm.semRegistro
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-center az-text-primary az-size-12 mb-3 ff-guia-simulacao__bloqueio",
              attrs: { "data-teste": "simulacao-sem-registro", role: "alert" }
            },
            [
              _c("icon-svg", {
                staticClass: "mr-1 flex-shrink-0",
                attrs: {
                  name: "warning",
                  size: 14,
                  color: "var(--danger-text)"
                }
              }),
              _vm._v(" " + _vm._s(_vm.textos.semRegistro) + " ")
            ],
            1
          )
        : _vm._e(),
      _vm.erroDeposito
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-center az-text-primary az-size-12 mb-3 ff-guia-simulacao__bloqueio",
              attrs: { "data-teste": "simulacao-erro-deposito", role: "alert" }
            },
            [
              _c("icon-svg", {
                staticClass: "mr-1 flex-shrink-0",
                attrs: {
                  name: "warning",
                  size: 14,
                  color: "var(--danger-text)"
                }
              }),
              _c("span", [_vm._v(_vm._s(_vm.erroDeposito))]),
              _c(
                "button",
                {
                  staticClass: "az-ds-hyperlink ml-1",
                  attrs: {
                    type: "button",
                    "data-teste": "simulacao-tentar-deposito-de-novo"
                  },
                  on: { click: _vm.redepositar }
                },
                [_vm._v(" " + _vm._s(_vm.textos.tentarDeNovo) + " ")]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex align-center justify-end az-gap-small" },
        [
          _c(
            "BaseButton",
            {
              attrs: {
                underlined: "",
                "fit-content": "",
                "data-teste": "simulacao-cancelar",
                disabled: _vm.processando
              },
              on: {
                click: function($event) {
                  return _vm.$emit("cancelar")
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.textos.cancelar) + " ")]
          ),
          _vm.previewId
            ? _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    "fit-content": "",
                    disabled: !_vm.podeSalvar,
                    loading: _vm.processando,
                    "data-teste": "simulacao-salvar"
                  },
                  on: { click: _vm.salvar }
                },
                [_vm._v(" " + _vm._s(_vm.textos.salvar) + " ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }